/**
 * Sesotho: Menu and frame
 *
 * What this file covers: The side menu, its section headings, the top bar, the profile menu and the frame
 * around every page.
 *
 * Tone: One or two words per item, like a sign on a door. Nouns, not sentences. Every label must fit a narrow
 * menu. The words chosen here are the names of the pages everywhere else.
 *
 * Sesotho: Everyday Sesotho as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const menu: Catalog = {
  'nav.section.workspace': 'Sebaka sa mosebetsi',
  'nav.section.audience': 'Bamameli',
  'nav.section.automation': 'Boiketsetso',
  'nav.section.settings': 'Litlhophiso',
  'nav.section.account': 'Ak\'haonte',
  'nav.dashboard': 'Deshboard',
  'nav.inbox': 'Lebokoso le kenang',
  'nav.contacts': 'Bao u ikopanyang le bona',
  'nav.broadcasts': 'Liphatlalatso',
  'nav.templates': 'Litemplate',
  'nav.flows': 'Liphallo',
  'nav.numbers': 'Linomoro',
  'nav.billing': 'Ho lefisa',
  'nav.settings': 'Litlhophiso',
  'nav.menu': 'Menyu',
  'shell.org.tooltip': 'Mokhatlo oa hao. Bula litlhophiso tsa mokhatlo.',
  'nav.openMenu': 'Bula tsamaiso',
  'nav.closeMenu': 'Koala tsamaiso',
  'shell.wallet.aria': 'Chelete e sepache {{amount}}. Bula tefo.',
  'nav.developers': 'Bahlahlobi ba ditshebeletso',
  'nav.channels': 'Dikanale'
};

export default menu;
